angular.module('jv.requisition.tabs.controller', [])
.controller('ReqsTabsCtrl', ['$scope','$location','$route','Reqs', 'hireCustomer', '$timeout', '$log', '$window', 'AutomationModal',
function ($scope, $location,$route, Reqs, isHireCustomer, $timeout, $log, $window, AutomationModal) {
    $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
    $scope.automationEngineEnabled = $window.automationEngineEnabled;
    $scope.result = {};
    $scope.requisitions = {};
    $scope.tabs = ['summary', 'details', 'candidates', 'lijobstatus', 'lirecommendations','','notes','activities', 'analytics'];
    $scope.jobLinkModal = {};
    $scope.jobLinkModal.show = false;
    $scope.notesCount=0;
    $scope.addNote = false;
    $scope.tabClicked;
    $scope.currentModal = {show:false};
    $scope.flags.loading=false;
    $scope.flags.paginated = false;
    $scope.hireCustomer = isHireCustomer;
    $scope.requisitions.selectedPosting='select';
    $scope.tbIndex=0;
    $scope.requisitions.showErrorResponse=false;
    $scope.requisitions.selectedPost='select';
    $scope.requisitions.postingTypes=[{'name':i18n['UPDATE_POST'],'value':'UPDATE'},{'name':i18n['RENEW_POST'],'value':'RENEW'}];
    $scope.isReqTemplateFlagEnabled = window.isReqTemplateFlagEnabled;
    $scope.modal = {
        show: false,
        title: i18n.CANNOT_OPEN_REQUISITION_TITLE,
        buttons: [
            {
                label: i18n.REQ_DETAILS_SUMMARY_CLOSE,
                title: i18n.REQ_DETAILS_SUMMARY_CLOSE,
                click: function(){
                    $scope.modal.show = false;
                }
            }
        ]
    };

    $scope.modalService = AutomationModal;

    var timeExceeded = true;

    // Used to display notices
    // var code = $scope.urlParams().code;

    /**
     * Used by Select2 AJAX
     */
    $scope.employeeSelect = Reqs.employeeSelect;
    $scope.getFieldMappedEmployees = Reqs.getFieldMappedEmployees;
    $scope.employeeSearch = Reqs.employeeSearch;
    $scope.returnURL= encodeURIComponent(window.location.href);
    $scope.locationMultiSelect = Reqs.locationMultiSelect;

    /**
     * Checks if any object in the array has the specified key.
     */
    $scope.hasKey = function(key, arr){
        for(var i=0; i < arr.length; i++){
            if(arr[i][key]){
                return true;
            }
        }
        return false;
    };

    /*** Biz Logic Methods follow ***/

    /**
     * Routes the request to appropriate tab depending on the tabIndex returned from the server. This is usually invoked
     * when a request is made from a controller but the response from the server contains data for a different tab then the
     * controller that requested the information.
     *
     */
    $scope.routeRequest = function(params, tabIndex){
        // Using an object as a String is not passed by Reference(calls to appendToPath).
        var queryString = {value: ''};

        // Using appendToPath as the attributes of param object may have undefined as value
        $scope.appendToPath(queryString, params.id).appendToPath(queryString, params.index).appendToPath(queryString, params.count).appendToPath(queryString, params.query);
        queryString = queryString.value;

        switch(tabIndex){
            case 0:  $location.path('/summary'+queryString);
                     break;

            case 1:  $location.path('/details'+queryString);
                     break;

            case 2:  $location.path('/candidates'+queryString);
                     break;
                     
            case 3:  $location.path('/lijobstatus'+queryString);
                     break;

            case 4:  $location.path('/lirecommendations'+queryString);
                     break;

            case 5:  $location.path('/notes'+queryString);
                     break;

            case 6: $location.path('/activity'+queryString);
                    break;

            default: $location.path('/details'+queryString);
                     break;

        }
    };

    /*
     * This method filters out appending 'fragment' variable, with undefined value, to the 'value' attribute of the object 'path' that is passed in(Otherwise JS auto type conversion
     * kicks in and concatenates the literal 'undefined').
     *
     * @return returns the $scope object for method chaining.
     *
     */
    $scope.appendToPath = function(path, fragment){
        if(typeof fragment !== 'undefined'){
            path.value = path.value + '/' + fragment;
        }
        return $scope;
    };

    //For holdjob action
    $scope.hold = function(){
        var data = {};
        data.id = $scope.requisitions.jobDetails.EId;
        /* Checking whether time exceeded 30 secs . Do not add readMode = 0 if time exceeds 30 secs*/
        if(!timeExceeded) {
            data.readMode = 0;
        }

        Reqs.hold(data, function(response){
            if(response.msgInfo === $scope.status.OK){
                angular.extend($scope.requisitions, response);
                $scope.$broadcast('onReqStatusUpdate', response);
            }
            else{
                $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
            }
        });
    };


    //For postjob action
    $scope.post = function(){
        var options = {};

        options.id = $scope.requisitions.jobDetails.EId;
        options.readMode = 0;

        Reqs.post(options,function(response){
            if(response.msgInfo === $scope.status.OK){
                startTimer();
                angular.extend($scope.requisitions, response);
                if ($scope.requisitions && $scope.requisitions.requisitionAnalytics) {
                    $scope.requisitions.requisitionAnalytics.daysOpen = response.daysOpen;
                }
                $scope.$broadcast('onReqStatusUpdate', response);
            } else if(response.msgInfo === 206) {
                $scope.showMsg('LANGUAGE_NOT_SUPPORTED', false, 'error');
            } else if(response.msgError === 412) {
                $scope.modal.show = true;
                $scope.modal.body = i18n.CANNOT_OPEN_REQUISITION_BODY;
            }
            else{
                $scope.showMsg('UNABLE_TO_PERFORM', false, 'error');
            }
        });
    };
    /*
     * Calculating 30 secs after the state changed to 'open' and then setting the flag to make 'on hold' state change with or without readMode = 0
     */
    function startTimer(){
        timeExceeded = false;
        $timeout(function(){
            timeExceeded = true;
        },30000);
    }

    //For openToDraft action
    $scope.openToDraft = function(){
       var options = {};

    options.id = $scope.requisitions.jobDetails.EId;
    options.readMode = 0;

        Reqs.openToDraft(options,function(response){
            if(response.msgInfo === $scope.status.OK){
                angular.extend($scope.requisitions, response);
            }
        });
    };


    /**
     * Method to show linkedin modal .
     */
    $scope.linkedInModal = function(){
        $scope.flags.loading=true;
        Reqs.userEmail($scope.requisitions.jobDetails.EId,
                function(response) {
                    $scope.flags.loading=false;
                    $scope.flags.valError = false;
                    $scope.flags.invalidEmail = false;
                    $scope.requisitions.posterEmail = response.posterEmail;
                    $scope.requisitions.locations = response.locations;
                    $scope.requisitions.contracts = response.contracts;
                    if($scope.requisitions.contracts && $scope.requisitions.contracts.premiumJobContracts && $scope.requisitions.contracts.premiumJobContracts.length===1){
                        $scope.requisitions.selectedContract = $scope.requisitions.contracts.premiumJobContracts[0].contract;
                    }
                    $scope.requisitions.linkedInmodal=true;
                    $('.modal select').trigger('liszt:updated');
                }
        );
    };

    /**
     * Set undefined to variables.
     */
    var setUndefined = (function () { return; }());

    /**
     * Method to show eQuest modal.
     */
    $scope.eQuestModal = function(){
        Reqs.eQuestData($scope.requisitions.jobDetails.EId,
                function(response) {
                    $scope.requisitions.eQuestData.category = JSON.parse(response.bean.additionalInteractonData);
                    $scope.requisitions.eQuestmodal=true;
                    $scope.requisitions.eQuest = {};
                    $scope.requisitions.eQuestData.subCategoryGroup = setUndefined;
                    $scope.requisitions.eQuestData.subCategory= setUndefined;
                    $scope.requisitions.eQuestData.subSubCategory = setUndefined;
                    $scope.requisitions.locations=response.locations;
                }
        );
    };

    // Private methods
    var paginate = function(){
        var queryString = '//'+$scope.params.index+'/'+$scope.params.count+'/'+$scope.params.query;
      //making activity tab sticky while navigating to next requisition
        if($scope.activeTab('#/activities')) {
            $scope.requisitions.tabIndex=6;
        } else if($scope.activeTab('#/notes')) {
            $scope.requisitions.tabIndex =5;
        } else if($scope.activeTab('#/analytics')) {
            $scope.requisitions.tabIndex =7;
        } else if($scope.activeTab('#/lirecommendations')){
            $scope.requisitions.tabIndex =4;
        } else if($scope.activeTab('#/lijobstatus')){
            $scope.requisitions.tabIndex =3;
        }
        queryString = $scope.tabs[$scope.requisitions.tabIndex] ? $scope.tabs[$scope.requisitions.tabIndex] + queryString : 'details' + queryString;
        $scope.flags.paginated = true;
        $scope.tabClicked = '';
        $location.path('/'+queryString);
    };

    $scope.prev = function(){
        var navAwayResult;
        if ($scope.params.index > 1) {
            if($scope.addNote) {
                navAwayResult = $scope.navAway('', true);
                if((typeof navAwayResult) !== 'undefined') {
                    if(navAwayResult) {
                        $window.$sZcope.notesCancel(); // Defined in ReqsNotesCtrl
                    }
                    else {
                        return;
                    }
                }
                else {
                    $scope.notesCancel(); // Defined in ReqsNotesCtrl
                }
            }
            $scope.params.index--;
            paginate();
        }
    };

    $scope.next = function(){
        var navAwayResult;
        if(parseInt($scope.params.index, 10) < parseInt($scope.params.count, 10) ){ // eslint-disable-line radix
            if($scope.addNote) {
                navAwayResult = $scope.navAway('', true);
                if((typeof navAwayResult) !== 'undefined') {
                    if(navAwayResult) {
                        $scope.notesCancel(); // Defined in ReqsNotesCtrl
                    }
                    else {
                        return;
                    }
                }
                else {
                    $scope.notesCancel(); // Defined in ReqsNotesCtrl
                }
            }
            $scope.params.index++;
            paginate();
        }
    };

 //Method for jobtarget
    $scope.postToJobTarget = function(){
    if($scope.requisitions.ShowMultipleLocations && $scope.requisitions.jobDetails.location){
        $scope.requisitions.jobTargetmodal=true;
    }
    else{
        $scope.flags.loading = true;
        Reqs.postToJobTarget($scope.requisitions.jobDetails.EId,null,
                function(response) {
                    $scope.flags.loading = false;
                    Reqs.jobBoard($scope.params.id, function(requisition){
                        angular.extend($scope.requisitions, requisition);
                        $scope.requisitions.filteredjobBoards = requisition.jobBoardPost;
                    });
                    if(response.bean){
                        var url = response.bean.interactionMetaData;
                        var tab = window.open(url);
                        if(typeof tab === 'undefined'){
                            $scope.showMsg('ENABLE_POPUP', false, 'error');
                        }
                    }
                    else{
                        $scope.showMsg('UNABLE_TO_POST_TO_JOBTARGET', false, 'error');
                    }
                }
        );
        }
    };
    /**
     * This method is called to get the requisition header info.
     * This is used when the user reloads the browser using F5, to get the requisition header.
     */
    $scope.initPageHeader = function(callback){
        Reqs.details({ id: $scope.params.id, index: $scope.params.index, count: $scope.params.count}, function(requisition){
            if (requisition.forumBaseUrl) {
                $scope.$root.forumBaseUrl = requisition.forumBaseUrl;
            }
            if(!requisition.jobDetails){
                return;
            }
            angular.extend($scope.requisitions, requisition);
            $scope.params.id = requisition.jobDetails.EId;
            $scope.requisitions.notesCount = requisition.notesCount ? requisition.notesCount : $scope.requisitions.notesCount;
            //If the user does not have access to summary tab, route them to details tab instead.
            if (!$scope.requisitions.views.summaryTab) {
                if ($scope.requisitions.views.detailsTab) {
                    $log.warn('Does not have access to job ' + $scope.params.id + 'summary page and trying to landing them on details page');
                    $location.path(('/details/' + $scope.params.id + '/' + $scope.params.index + '/' + $scope.params.count + '/' + $scope.params.query).replace(/\/undefined/gi,''));
                } else {
                    //Route them to list page.
                    $log.warn('Does not have access to job ' + $scope.params.id + 'details page and landing them on list page');
                    $location.path($window.jvUrls.jhire + '/modules/requisitions/list.html');
                }
            }
            if(requisition.msgInfo){
                $scope.showMsg(requisition.msgInfo);
            }
            if (callback) {
                callback();
            }
        });
    };


    $scope.toggleAddNoteForm = function(){
        $scope.addNote=!$scope.addNote;
        //NavAway code removed from here. navAway functionality handled in directives 'jvWarndirty'
    };

    $scope.quickReq = function(appId) {
        /**
            This accepts the applicationId and the candidateEid
        **/
        var data = {};
        data.id = appId;
        //data.eid = candId;
        if ($scope.isNewJQuery) {
            $window.jv.modalNew.init(data, 'jv-modalDialog');
        } else {
            $window.jv.modal.init(data, 'jv-modalDialog');
        }

    };

    /*
    * JV.Person.makeCallForQuickViewOverlayForApplication is a function call is appended to <a> tab by BE generated HTML
    * We must overwrite this function in same format to make it working
    */
    $window.JV.Person.makeCallForQuickViewOverlayForApplication = function(appId) {
        var ev = window.event;
        if(ev.preventDefault) {
            ev.preventDefault();
        } else {
            //IE
            ev.returnValue = false;
        }
        appId && $scope.quickReq(appId);
        // $scope.showMsg('STATUS_UPDATED');
        // $('.jv-closeModalDialog').trigger('click');
    };
    $window.JV.Util.showMessage = angular.noop;
    $scope.$on('rejectCandidateSuccess', function() {
        $scope.flags.loading = false;
    });

    $scope.deleteModal = {
            show : false,
            ok: function(){
                // UT: Check for show flag being true an return otherwise.
                Reqs.deleteReq($scope.params, function(response){
                    if(response.msgInfo === 200){
                        window.location = 'list.html?code=REQUISITION_DELETED&readMode=0';
                    }else{
                        $scope.showErrorMsg = true;
                        setTimeout(function(){
                            $scope.$apply('showErrorMsg = false');
                        },5000);
                    }
                });
                $scope.deleteModal.show = false;
            },
            cancel: function(){
                $scope.deleteModal.show = false;
            },

            okTitle : i18n.REQ_DELETE_OK,
            cancelTitle: i18n.REQ_DELETE_CANCEL,
            title: i18n.DELETE_REQUISITION,
            body: i18n.REQ_DELETE_BODY
    };

    $scope.deleteReq = function(){
        $scope.currentModal = $scope.deleteModal;
        $scope.currentModal.show = true;
    };


    //method added to show renew or update popup based on passed action
    $scope.decidePosting=function(index){
     Reqs.userEmail($scope.requisitions.jobDetails.EId,
                    function(response) {
                        $scope.flags.loading=false;
                        $scope.flags.valError = false;
                        $scope.flags.invalidEmail = false;
                        $scope.requisitions.posterEmail = response.posterEmail;
                        $scope.requisitions.locations = response.locations;
                        $scope.requisitions.contracts = response.contracts;
                        if($scope.requisitions.contracts && $scope.requisitions.contracts.premiumJobContracts && $scope.requisitions.contracts.premiumJobContracts.length===1){
                            $scope.requisitions.selectedContract = $scope.requisitions.contracts.premiumJobContracts[0].contract;
                        }
                    }
            );
        $scope.requisitions.selectedPost=$scope.requisitions.selectedPosting;
        switch ($scope.requisitions.selectedPost) {
            case 'RENEW':
                 $scope.requisitions.linkedRenewModel=true;
                 $scope.tbIndex=index;
                 $scope.requisitions.selectedPosting='select';
                 $scope.requisitions.showErrorResponse = false;
                 break;
            case 'UPDATE':
                var linkedInJobPost= $scope.requisitions.linkedinJobPosting[index];
                var linkedInDto = linkedInJobPost.jobPostData.linkedInPremiumJobDTO[0];
               $scope.requisitions.posterEmail = linkedInDto.posterEmail;
               $scope.requisitions.selectedlocation=linkedInJobPost.location;
               $scope.requisitions.selectedlocations=linkedInJobPost.locationEId;
               setTimeout(function() {
                   if(!$scope.$$phase || !$scope.$root.$$phase){
                    $('#contractFieldId').val(linkedInDto.contract.replace(/\D/g, '')).trigger('change');
                    $('#industryFieldId').val(linkedInDto.industries).trigger('change');
                    $('#jobFunctionFieldId').val(linkedInDto.categories).trigger('change');
                    $('#jobTypeFieldId').val(linkedInDto.employmentStatus).trigger('change');
                    $('#experienceLevelFieldId').val(linkedInDto.experienceLevel).trigger('change');
                   }
               });

               $scope.requisitions.linkedInUpdateModal=true;
               $scope.requisitions.selectedPosting='select';
               $scope.requisitions.showErrorResponse = false;
             break;
             default:
        }
    };

    $scope.getLinkedInPremiumJobPostStatus = function() {
        Reqs.getLinkedInPremiumJobPostStatus($scope.requisitions.jobDetails.EId  ,function(response) {
            if(response) {
                    $scope.requisitions.linkedinJobPosting = response;

            }
        });
   };

   //method added to renew the linkedIn paid posting action
   $scope.renewLinkedPosting=function(){
       var selectedPosting=$scope.requisitions.selectedPost;
       var linkedInJobPost= $scope.requisitions.linkedinJobPosting[$scope.tbIndex];
       var linkedInDto = linkedInJobPost.jobPostData.linkedInPremiumJobDTO[0];
       var postData = {
           j: $scope.requisitions.jobDetails.EId,
            posterEmail: linkedInDto.posterEmail,
            expCode: linkedInDto.experienceLevel,
            //  role: $scope.role,
            jobType: linkedInDto.employmentStatus,
            loc:linkedInJobPost.locationEId,
            contract:linkedInJobPost.contractId,
            industries: linkedInDto.industries,
            jobFunctions: linkedInDto.categories,
            linkedInAction:selectedPosting
        };

       Reqs.postToLinkedIn(postData, $scope.requisitions.jobDetails.EId,
               function (response) {
                   if (response.msgError) {
                       if (response.msgError >= 200 && response.msgError <=299) {
                          // $scope.cancel();
                           $scope.requisitions.linkedRenewModel=false;
                           $scope.showMsg('JOB_POSTED');
                           $scope.getLinkedInPremiumJobPostStatus();
                       } else if (response.msgError === 412) {
                           $scope.requisitions.linkedErrorMessage = i18n['LINKEDIN_UNAUTHORIZED'];
                           $scope.requisitions.showErrorResponse = true;
                       }else {
                           $scope.requisitions.showErrorResponse = true;
                           var error=response.msgError;
                           var contractId=linkedInJobPost.contractId;
                           if(error===400||error===404||error===500||error===504||error===401||error===402||error===409){
                           $scope.linkedErrorMessage = i18n['linkedInErrorcode' + error].format(contractId);
                           }else{
                             $scope.linkedErrorMessage = i18n['linkedInErrorcode'].format(contractId);
                           }
                       }
                   } else {
                       $scope.linkedErrorMessage = response && response.error_message;
                       $scope.requisitions.showErrorResponse = true;
                   }
               }
           );
   };

   $scope.cancelRenew=function(){
        $scope.requisitions.linkedRenewModel=false  ;
        $scope.requisitions.selectedPosting='select';
        $scope.requisitions.linkedInmodal = false;
        $scope.requisitions.linkedInUpdateModal=false;
        $scope.requisitions.selectedPosting='select';
        $scope.requisitions.selectedlocations = '';
        $scope.requisitions.selectedContract = '';
        $scope.selectedPostalCode = '';
        $scope.showErrorResponse = false;
        $scope.industries = '';
        $scope.jobFunctions = '';
        $scope.flags.valError = false;
        $scope.flags.invalidEmail = false;
        $scope.role = '';
        $scope.expCode = '';
        $scope.jobType = '';
        $scope.requisitions.selectedlocation='';
        $scope.getLinkedInPremiumJobPostStatus();
   };
     $scope.disablePosting=function(selectedItem,selectedRow){
          var currentDate=new Date();
          var releaseDateTime=1579219200000;// ms 17 Jan-2020 00:00:00
         if(selectedRow.jobPostedDate<releaseDateTime){
            return true;
          }else if(selectedRow.jobStatus==='FAILED' || selectedRow.jobStatus==='IN_PROGRESS'){
              return true;
          }else if(currentDate.getTime()>selectedRow.expirationDate){
               return selectedItem.value==='UPDATE';
          }else{
               return false;
          }

      };

    $scope.getVonqCampaigns = function() {
        Reqs.getVonqCampaigns($scope.requisitions.jobDetails.EId  ,function(response) {
            $scope.requisitions.vonqCampaignSummary = response;
        });
    };

    const postProcessVonqPosting = function(result) {
        var postData = {jobEId: $scope.requisitions.jobDetails.EId, campaignId: result.campaignId};
        Reqs.saveVonqCampaign(postData, function(response){
            if (response.msgInfo && response.msgInfo === 201) {
                $scope.getVonqCampaigns();
            } else {
                $scope.showMsg('UNABLE_TO_POST_TO_VONQ', false, 'error');
            }
        });
    };
    var validatePostingData = function(reqData){
        reqData.isValid = true;
        if(!reqData.jobTypeInstance || !reqData.jobTypeInstance.name) {
            reqData.isValid = false;
            reqData.code = 'Required field Job Type is missing.';
            return reqData;
        }
        if(!reqData.location) {
            reqData.isValid = false;
            reqData.code = 'Required field Job location is missing.';
            return reqData;
        }
        return reqData;
    };

    $scope.postToVonq = function(){
        var postingData = validatePostingData($scope.requisitions.jobDetails);
        if(postingData.isValid){
            Reqs.mapJobToHapiElementsCampaignForm(postingData);
            $scope.requisitions.vonqModal = true;
            Reqs.registerCampaignOnSuccessEvent(postProcessVonqPosting);
        } else {
            $scope.showMsg(postingData.code, true, 'error');
        }
    };


    $scope.trigger = function(companyAutomationId){
        const referenceKey = $scope.requisitions.jobDetails.EId;
        const triggerType = 'REQ_STATUS_CHANGE';
        Reqs.postRulesTrigger(companyAutomationId, referenceKey, triggerType, function(response) {
            if (response.msgInfo === 200) {
                $scope.flags.loading = false;

                if (jQuery.fn.jquery.split('.')[0] === '3') {
                    $(window).off('beforeunload');
                } else {
                    $(window).unbind('beforeunload');
                }
            }
        });
    };

    $scope.$watch('requisitions.jobDetails', function(newValue) {
        if (angular.isDefined(newValue)) {
            getAutomations();
        }
    });

    $scope.$watch('modelService.state.tableData');

    function getAutomations() {
        const referenceKey = $scope.requisitions.jobDetails.EId;
        const triggerValue = $scope.requisitions.jobDetails.jobStateRaw;
        const automationType = 'ON_DEMAND';
        if ($scope.automationEngineEnabled && referenceKey) {
            $scope.modalService.getAutomationsModalData(referenceKey, triggerValue, automationType);
        }
    }

    $scope.modalService.callbackFunction = $scope.trigger;

}
]);
